import { render } from "./RuiScba.vue?vue&type=template&id=f93bedd2"
const script = {}
script.render = render

export default script